import { toggleModal } from "@/core/reatom/state/modal/modal";
import {
  paymentLinkAsync,
  currentOrderAtom,
  isLoadingCurrentOrderAtom,
  cancelOrderAction,
  currentOrderArbitrageAtom,
  doneOrderAction,
  fixOrderAction,
  isLoadingArbitrageAtom,
} from "@/core/reatom/state/orders/orders";
import { useAtom, useAction } from "@reatom/npm-react";
import clsx from "clsx";
import { useNavigate, useParams } from "react-router";
import { Block } from "../Block/Block";
import { UIButton } from "../UIButton/UIButton";
import s from "./style.module.scss";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { freelanceAction } from "@/core/reatom/state/search";
import { ProcessStatus } from "@/core/reatom/state/orders/types";
import { OrderInfo } from "../OrderInfo/OrderInfo";
import { openLink } from "@telegram-apps/sdk-react";
import { useEffect } from "react";
import { feedbackAtom } from "@/core/reatom/state/feedback/feedback";
import { SpinLoader } from "../SpinLoader/SpinLoader";
dayjs.locale("ru");

type ButtonsConfig = {
  [key in ProcessStatus | "arbitrage"]?: {
    first: {
      title: string;
      onClick?: () => void;
    };
    second: {
      title: string;
      onClick?: () => void;
    };
    third?: {
      title: string;
      onClick?: () => void;
    };
  };
};
export const OrderEpic = () => {
  const [link] = useAtom(paymentLinkAsync.dataAtom);
  const { id } = useParams();
  const [currentOrder] = useAtom(currentOrderAtom);
  const [isLoadingCurrentOrder] = useAtom(isLoadingCurrentOrderAtom);
  const [isLoadingArbitrage] = useAtom(isLoadingArbitrageAtom);

  const handleCancelOrder = useAction(cancelOrderAction);
  const handleDoneOrder = useAction(doneOrderAction);
  const handleFixOrder = useAction(fixOrderAction);
  const handleToggleModal = useAction(toggleModal);
  const handleSearchFreelancer = useAction(freelanceAction);
  const navigate = useNavigate();
  const [currentOrderArbitrage] = useAtom(currentOrderArbitrageAtom);
  const getPaymentLink = useAction(paymentLinkAsync);
  const status = currentOrder?.is_arbitrage
    ? "arbitrage"
    : currentOrder?.process_status;
  useEffect(() => {
    if (currentOrder?.id && status === "new") {
      getPaymentLink(Number(currentOrder?.id));
    }
  }, [currentOrder]);
  const [feedback] = useAtom(feedbackAtom);

  const userFeedback = feedback?.items.find(
    (item) => item.author.id === currentOrder?.author.id
  );

  const buttons: ButtonsConfig = {
    new: {
      first: {
        title:
          currentOrder?.reserve.status === "reserved"
            ? "Перейти в чат с фрилансером"
            : `Оплатить ${currentOrder?.reserve_price?.toLocaleString(
                "ru-RU"
              )} ₽`,
        onClick: () =>
          currentOrder?.reserve.status === "reserved"
            ? navigate("/messages/" + currentOrder?.id)
            : handleToggleModal("payment"),
      },
      second: {
        title: "Отменить заказ",
        onClick: () => currentOrder?.id && handleCancelOrder(currentOrder?.id),
      },
    },
    cancelled: {
      first: {
        title: "Перейти в услуги исполнителя",
        onClick: () => {
          handleSearchFreelancer({ user_id: currentOrder?.freelancers[0].id });
          navigate("/freelancer/" + currentOrder?.freelancers[0].id);
        },
      },
      second: {
        title: "Вернуться в каталог",
        onClick: () => {
          navigate("/");
        },
      },
    },
    not_answered: {
      first: {
        title: "Перейти в услуги исполнителя",
        onClick: () => {
          handleSearchFreelancer({ user_id: currentOrder?.freelancers[0].id });
          navigate("/freelancer/" + currentOrder?.freelancers[0].id);
        },
      },
      second: {
        title: "Вернуться в каталог",
        onClick: () => {
          navigate("/");
        },
      },
    },
    declined: {
      first: {
        title: "Перейти в чат с фрилансером",
        onClick: () => {
          navigate("/messages/" + currentOrder?.id);
        },
      },
      second: {
        title: "Вернуться в каталог",
        onClick: () => {
          navigate("/");
        },
      },
    },
    accepted: {
      first: {
        title: "Перейти в чат с фрилансером",
        onClick: () => {
          navigate("/messages/" + currentOrder?.id);
        },
      },
      second: {
        title: "Завершить сотрудничество",
        onClick: () => handleToggleModal(`feedback`),
      },
    },
    work_finished: {
      first: {
        title: "Перейти в чат с фрилансером",
        onClick: () => {
          navigate("/messages/" + currentOrder?.id);
        },
      },
      second: {
        title: "Завершить сотрудничество",
        onClick: () => handleToggleModal(`feedback`),
      },
      third: {
        title: "Вернуть заказ в работу",
        onClick: () => currentOrder?.id && handleFixOrder(currentOrder?.id),
      },
    },
    fix: {
      first: {
        title: "Перейти в чат с фрилансером",
        onClick: () => {
          navigate("/messages/" + currentOrder?.id);
        },
      },
      second: {
        title: "Завершить сотрудничество",
        onClick: () => handleToggleModal(`feedback`),
      },
    },
    arbitrage: {
      first: {
        title: "Перейти в чат с фрилансером",
        onClick: () => {
          navigate("/messages/" + currentOrder?.id);
        },
      },
      second: {
        title: currentOrderArbitrage?.emp_allow_feedback
          ? "Оставить отзыв"
          : "Вернуться в каталог",
        onClick: currentOrderArbitrage?.emp_allow_feedback
          ? () => handleToggleModal(`feedback:1`)
          : () => navigate("/"),
      },
    },
    completed: {
      first: {
        title: "Перейти в чат с фрилансером",
        onClick: () => {
          navigate("/messages/" + currentOrder?.id);
        },
      },
      second: {
        title:
          currentOrderArbitrage?.emp_allow_feedback && !userFeedback
            ? "Оставить отзыв"
            : "Вернуться в каталог",
        onClick:
          currentOrderArbitrage?.emp_allow_feedback && !userFeedback
            ? currentOrderArbitrage.id
              ? () => handleToggleModal(`feedback:1`)
              : () => handleToggleModal(`feedback`)
            : () => navigate("/"),
      },
    },
  };

  const currentButton =
    status && status in buttons
      ? buttons[status as keyof typeof buttons]
      : undefined;
  if (isLoadingCurrentOrder || isLoadingArbitrage) {
    return (
      <Block borderRadius="top" className={s.epic}>
        <SpinLoader />
      </Block>
    );
  }

  return (
    <Block borderRadius="top" className={s.epic}>
      <div className={s.mobile}>
        <OrderInfo />
      </div>
      {/* {currentOrder?.reserve.status === "new" && */}
      {currentButton && (
        <div className={s.epicButtons}>
          {currentButton.first && (
            <UIButton
              fontType="primary-2"
              className={s.button}
              onClick={currentButton.first.onClick}
            >
              {currentButton.first.title}
            </UIButton>
          )}
          {currentButton.second && (
            <UIButton
              fontType="primary-2"
              color="inverted"
              className={clsx(s.button, s.closeButton)}
              onClick={currentButton.second.onClick}
            >
              {currentButton.second.title}
            </UIButton>
          )}
          {currentButton?.third && (
            <UIButton
              fontType="primary-2"
              color="inverted"
              className={clsx(s.button, s.closeButton)}
              onClick={currentButton.third.onClick}
            >
              {currentButton.third.title}
            </UIButton>
          )}
        </div>
      )}
      {currentOrder?.process_status === "new" &&
        currentOrder.reserve?.status !== "reserved" && (
          <div className={s.mobile}>
            <p className={s.offerta}>
              Я принимаю условия{" "}
              <span
                onClick={() => {
                  openLink(
                    "https://st.fl.ru/about/documents/uslugi-freelancera/contract_fiz.pdf"
                  );
                }}
              >
                Оферты на заключение Договора об использовании онлайн сервиса
                «Защищенная Сделка в рамках сервиса Типовые услуги»,
              </span>{" "}
              <span
                onClick={() => {
                  openLink(
                    "https://st.fl.ru/about/documents/uslugi-freelancera/agreement_fiz.pdf"
                  );
                }}
              >
                Оферты на заключение соглашения о выполнении работы и/или
                оказании услуги,
              </span>{" "}
              <span
                onClick={() => {
                  openLink("https://kassa.com/offers/fl");
                }}
              >
                Публичной оферты об использовании Платежного сервиса «Безопасный
                перевод»
              </span>{" "}
              и соглашаюсь на сотрудничество в их рамках.
            </p>
          </div>
        )}
    </Block>
  );
};
